
export const onboardingQuestions = [
  {
    headline: "Let's get started! 👋",
    subtext: "We're excited to have you join the Show Up! experiment",
    type: 'input' as const
  },
  {
    headline: "What motivated you to sign up for Show Up! today?",
    subtext: "Help us understand what brought you here",
    type: 'radio' as const,
    field: 'motivation' as const,
    options: [
      "I'm tired of starting things and never finishing them",
      "I want to try something different from other habit apps",
      "I'm curious about the PACT method",
      "A friend or someone recommended it",
      "I'm looking for accountability and support",
      "I want to experiment with my life",
      "Other comments"
    ]
  },
  {
    headline: "What's your experience with building habits?",
    subtext: "No judgment here - we want to understand your journey",
    type: 'radio' as const,
    field: 'experience' as const,
    options: [
      "I've tried habit apps before (they didn't work for me)",
      "I've never used habit apps",
      "I'm currently using a habit app",
      "I prefer pen and paper methods",
      "I struggle to stick to anything consistently"
    ]
  },
  {
    headline: "What's your biggest challenge when trying to build new habits?",
    subtext: "This helps us understand if Show Up! can truly help you",
    type: 'radio' as const,
    field: 'challenge' as const,
    options: [
      "I start strong but give up quickly",
      "I feel guilty and ashamed when I miss days",
      "Apps are too complicated or overwhelming",
      "I don't know what habits to focus on",
      "I lack motivation and accountability",
      "I get bored and lose interest"
    ]
  },
  {
    headline: "If Show Up! could help you in ONE area of life, what would it be?",
    subtext: "Choose the area where you most want to 'show up'",
    type: 'radio' as const,
    field: 'useCase' as const,
    options: [
      "Health & Fitness (exercise, nutrition, sleep)",
      "Work & Productivity (focus, deep work, skills)",
      "Learning & Personal Growth (reading, courses, hobbies)",
      "Relationships & Social (family time, friendships, networking)",
      "Mental Health & Mindfulness (meditation, journaling, self-care)",
      "Creative Projects (writing, art, music, side projects)",
      "Others"
    ]
  },
  {
    headline: "Would you be willing to participate in a 15-minute interview?",
    subtext: "We'd love to gather more insights and experience to improve Show Up!",
    type: 'radio' as const,
    field: 'interviewInterest' as const,
    options: [
      "Yes, I'm interested",
      "No, thanks"
    ]
  }
];
